// extracted by mini-css-extract-plugin
export default {"img":"image_img__qooOS","--stub":"image_--stub__KMD7E"};